import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useSsoCart } from "../../../../contexts/SsoCartContext";
import "./PaymentSuccess.css";
/*istanbul ignore next */
const PaymentSuccess = () => {
  const history = useHistory();
  const { cart, getCartDetails } = useSsoCart();
  const [cartItems, setCartItems] = useState([]);
  const [returnUrl, setReturnUrl] = useState("");
  const [isFolderReceived, setIsFolderReceived] = useState(false);
  const [isMigration, setIsMigration] = useState(false);
  const [isEditPackage, setIsEditPackage] = useState(false);
  const [isPackageReceived, setIsPackageReceived] = useState(false);
  const [isHome, setIsHome] = useState(false);

  useEffect(() => {
    const refreshCart = async () => {
      try {
        const result = await getCartDetails();
        if (result?.success) {
          const items = result.data || [];
          setCartItems(items);
        }
      } catch (error) {
        console.log(`Exception while doing something: ${error}`);
      }
    };
    const timer = setTimeout(() => {
      refreshCart();
    }, 100);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      const ssoLoginData = localStorage.getItem("ssoResponse");
      if (ssoLoginData) {
        const parsedData = JSON.parse(ssoLoginData);
        const url = parsedData.result.returnUrl;
        setReturnUrl(url);
        const normalizedUrl = typeof url === "string" ? url.toLowerCase() : "";

        setIsFolderReceived(normalizedUrl.includes("folderrecieved"));
        setIsMigration(normalizedUrl.includes("efwimport"));
        setIsEditPackage(normalizedUrl.includes("editpackage"));
        setIsPackageReceived(normalizedUrl.includes("packagereceived"));
        setIsHome(normalizedUrl.includes("home"));
      }
    } catch (error) {
      console.error("Error reading returnUrl from ssoLoginData:", error);
    }
  }, []);

  const handleContinueShopping = () => {
    history.push("/purchase");
  };

  const handleGoToCart = () => {
    history.push("/purchase/cart");
  };

  const renderPrimaryButton = () => {
    const itemsToCheck = cartItems.length > 0 ? cartItems : cart;
    if (itemsToCheck.length > 0) {
      return (
        <button className="btn-continue-shopping" onClick={handleGoToCart}>
          GO TO CART
        </button>
      );
    }

    return (
      <button
        className="btn-continue-shopping"
        onClick={handleContinueShopping}
      >
        CONTINUE SHOPPING
      </button>
    );
  };

  const renderSuccessMessage = () => {
    const itemsToCheck = cartItems.length > 0 ? cartItems : cart;

    if (itemsToCheck.length > 0) {
      // Scenario B - Pending items exist in cart
      return (
        <p className="success-message">
          You still have items pending in your cart.
        </p>
      );
    }

    // Scenario A - No pending items in cart
    return (
      <p className="success-message">
        Continue exploring available content, or return to the app.
      </p>
    );
  };

  let goContentLabel = "GO TO MY CONTENT";
  if (isMigration) {
    goContentLabel = "GO TO MIGRATION";
  } else if (isFolderReceived) {
    goContentLabel = "GO TO IMPORT FOLDER";
  } else if (isEditPackage) {
    goContentLabel = "GO TO PACKAGE TEMPLATE";
  } else if (isPackageReceived) {
    goContentLabel = "GO TO IMPORT PACKAGE";
  } else if (isHome) {
    goContentLabel = "GO TO HOME";
  }

  return (
    <div className="payment-success-container">
      <div className="payment-success-content">
        <div className="success-icon-wrapper">
          <CheckCircleOutlineIcon className="success-icon" />
        </div>
        <h1>Your order has been purchased!</h1>
        {renderSuccessMessage()}
        <div className="success-buttons">
          {renderPrimaryButton()}
          <a href={returnUrl || '/purchase'} className="btn-go-content">
            {goContentLabel}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
